import { render, staticRenderFns } from "./vredit.vue?vue&type=template&id=f12c8c5e&scoped=true&"
import script from "./vredit.vue?vue&type=script&lang=js&"
export * from "./vredit.vue?vue&type=script&lang=js&"
import style0 from "./vredit.vue?vue&type=style&index=0&id=f12c8c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12c8c5e",
  null
  
)

export default component.exports